import { Component } from 'react';
import { createPortal } from 'react-dom';

import { ID_PORTAL_LAYER_CONTROLS } from 'legacy/appstore/constants';

class HeatmapControlPanel extends Component {
  state = {
    target: null
  };
  targetTimeout = null;

  componentDidMount() {
    this.setTarget();
  }

  componentWillUnmount() {
    window.clearTimeout(this.targetTimeout);
  }

  setTarget = () => {
    const target = document.getElementById(ID_PORTAL_LAYER_CONTROLS);
    if (target) {
      this.setState({ target });
    } else {
      // Retry in case the target div has not mounted
      this.targetTimeout = window.setTimeout(this.setTarget, 250);
    }
  };

  render() {
    const { LayerControlsComponent } = this.props;
    const { target } = this.state;
    if (target) {
      return createPortal(LayerControlsComponent, target);
    } else {
      return null;
    }
  }
}

export default (props) => <HeatmapControlPanel {...props} />;
